import createLucideIcon from '../createLucideIcon';

const MoveDownRight = createLucideIcon('MoveDownRight', [
  ['path', { d: 'M19 13V19H13', key: '10vkzq' }],
  ['path', { d: 'M5 5L19 19', key: '5zm2fv' }],
]);

export default MoveDownRight;
